<select class="amount-select" name="quantity" [(ngModel)]="itemCount" (ngModelChange)="onAmountChange($event)" [disabled]="isDisabled" [attr.aria-label]="'shop.item.count' | translate: {itemName: itemName}">
    <option *ngFor="let _ of [].constructor(maxAmount); let i = index;" [value]="i + 1">{{i + 1}}</option>
</select>
